module.exports = __webpack_public_path__ + "static/app-upsell-desktop-7c4cb2d110dc84d4f8add6415fc94e3b.png";